import { createIcon } from './create-icon'

export const ChevronDown = createIcon({
  displayName: 'ChevronDown',
  paths: [
    'M512 682.667c-10.923 0-21.845-4.181-30.165-12.501l-256-256c-16.683-16.683-16.683-43.648 0-60.331s43.648-16.683 60.331 0l225.834 225.834 225.835-225.834c16.683-16.683 43.648-16.683 60.331 0s16.683 43.648 0 60.331l-256 256c-8.32 8.32-19.243 12.501-30.165 12.501z'
  ]
})
